export const assessmentQuestions=[
  // Personal Demographics
  {
    id: 'age',
    category: 'demographics',
    type: 'select',
    question: 'What is your age range?',
    options: [
      {value: '18-25',label: '18-25'},
      {value: '26-35',label: '26-35'},
      {value: '36-45',label: '36-45'},
      {value: '46-55',label: '46-55'},
      {value: '56-65',label: '56-65'},
      {value: '65+',label: '65+'}
    ],
    weight: 0.8
  },
  // Removed Gender, Height, Build (Reduced from 4 to 1 demographic question)

  // Living Situation
  {
    id: 'housing-type',
    category: 'living',
    type: 'select',
    question: 'What type of housing do you live in?',
    options: [
      {value: 'apartment',label: 'Apartment/Condo'},
      {value: 'small-house',label: 'Small House'},
      {value: 'large-house',label: 'Large House'},
      {value: 'farm',label: 'Farm/Rural Property'}
    ],
    weight: 1.0
  },
  {
    id: 'yard-space',
    category: 'living',
    type: 'select',
    question: 'What outdoor space do you have access to?',
    options: [
      {value: 'none',label: 'No outdoor space'},
      {value: 'balcony',label: 'Balcony/Patio only'},
      {value: 'small-yard',label: 'Small yard'},
      {value: 'large-yard',label: 'Large yard'},
      {value: 'acreage',label: 'Multiple acres'}
    ],
    weight: 0.9
  },
  {
    id: 'household-members',
    category: 'living',
    type: 'multiselect',
    question: 'Who lives in your household?',
    options: [
      {value: 'live-alone',label: 'I live alone'},
      {value: 'spouse-partner',label: 'Spouse/Partner'},
      {value: 'children-under-5',label: 'Children under 5'},
      {value: 'children-5-12',label: 'Children 5-12'},
      {value: 'teenagers',label: 'Teenagers'},
      {value: 'elderly',label: 'Elderly family members'},
      {value: 'roommates',label: 'Roommates'}
    ],
    weight: 1.0
  },
  {
    id: 'other-pets',
    category: 'living',
    type: 'multiselect',
    question: 'Do you have other pets?',
    options: [
      {value: 'none',label: 'No other pets'},
      {value: 'dogs',label: 'Other dogs'},
      {value: 'cats',label: 'Cats'},
      {value: 'small-pets',label: 'Small pets (rabbits,hamsters,etc.)'},
      {value: 'birds',label: 'Birds'},
      {value: 'reptiles',label: 'Reptiles'}
    ],
    weight: 0.9
  },
  // Lifestyle & Activity
  {
    id: 'activity-level',
    category: 'lifestyle',
    type: 'select',
    question: 'How would you describe your activity level?',
    options: [
      {value: 'sedentary',label: 'Sedentary - Minimal physical activity'},
      {value: 'light',label: 'Light - Occasional walks/light exercise'},
      {value: 'moderate',label: 'Moderate - Regular exercise 2-3 times/week'},
      {value: 'active',label: 'Active - Exercise 4-5 times/week'},
      {value: 'very-active',label: 'Very Active - Daily intense exercise'}
    ],
    weight: 1.0
  },
  {
    id: 'work-schedule',
    category: 'lifestyle',
    type: 'select',
    question: 'What is your typical work schedule?',
    options: [
      {value: 'work-from-home',label: 'Work from home'},
      {value: 'part-time',label: 'Part-time (under 30 hours/week)'},
      {value: 'full-time-regular',label: 'Full-time regular hours'},
      {value: 'full-time-long',label: 'Full-time long hours (50+ hours/week)'},
      {value: 'shift-work',label: 'Shift work/irregular hours'},
      {value: 'retired',label: 'Retired'},
      {value: 'student',label: 'Student'}
    ],
    weight: 0.9
  },
  {
    id: 'travel-frequency',
    category: 'lifestyle',
    type: 'select',
    question: 'How often do you travel?',
    options: [
      {value: 'never',label: 'Rarely/Never'},
      {value: 'few-times-year',label: 'A few times per year'},
      {value: 'monthly',label: 'Monthly'},
      {value: 'weekly',label: 'Weekly'},
      {value: 'frequent',label: 'Very frequently'}
    ],
    weight: 0.7
  },
  {
    id: 'outdoor-activities',
    category: 'lifestyle',
    type: 'multiselect',
    question: 'Which outdoor activities do you enjoy?',
    options: [
      {value: 'hiking',label: 'Hiking'},
      {value: 'running',label: 'Running/Jogging'},
      {value: 'cycling',label: 'Cycling'},
      {value: 'camping',label: 'Camping'},
      {value: 'beach',label: 'Beach activities'},
      {value: 'gardening',label: 'Gardening'},
      {value: 'sports',label: 'Outdoor sports'},
      {value: 'none',label: 'I prefer indoor activities'}
    ],
    weight: 0.6
  },
  // Personality & Psychology
  {
    id: 'personality-type',
    category: 'personality',
    type: 'select',
    question: 'How would you describe your personality?',
    options: [
      {value: 'introverted-calm',label: 'Introverted and calm'},
      {value: 'introverted-anxious',label: 'Introverted but anxious'},
      {value: 'extroverted-energetic',label: 'Extroverted and energetic'},
      {value: 'extroverted-social',label: 'Extroverted but prefer calm social settings'},
      {value: 'balanced',label: 'Balanced between introverted and extroverted'}
    ],
    weight: 0.9
  },
  {
    id: 'stress-level',
    category: 'personality',
    type: 'select',
    question: 'How do you handle stress?',
    options: [
      {value: 'very-well',label: 'Very well - I stay calm under pressure'},
      {value: 'well',label: 'Well - I manage stress effectively'},
      {value: 'moderate',label: 'Moderately - Sometimes overwhelmed'},
      {value: 'poorly',label: 'Poorly - I get stressed easily'},
      {value: 'very-poorly',label: 'Very poorly - High anxiety/stress levels'}
    ],
    weight: 0.8
  },
  {
    id: 'patience-level',
    category: 'personality',
    type: 'select',
    question: 'How patient are you with training and behavioral issues?',
    options: [
      {value: 'very-patient',label: 'Very patient - I enjoy the training process'},
      {value: 'patient',label: 'Patient - I can work through issues'},
      {value: 'moderate',label: 'Moderately patient'},
      {value: 'impatient',label: 'Somewhat impatient'},
      {value: 'very-impatient',label: 'Very impatient - I want quick results'}
    ],
    weight: 0.9
  },
  {
    id: 'emotional-needs',
    category: 'personality',
    type: 'multiselect',
    question: 'What emotional needs would you like a dog to fulfill?',
    options: [
      {value: 'companionship',label: 'Companionship'},
      {value: 'emotional-support',label: 'Emotional support'},
      {value: 'security',label: 'Security/Protection'},
      {value: 'social-connection',label: 'Social connections with other dog owners'},
      {value: 'purpose',label: 'Sense of purpose/responsibility'},
      {value: 'stress-relief',label: 'Stress relief'},
      {value: 'active-lifestyle',label: 'Motivation for active lifestyle'}
    ],
    weight: 0.7
  },
  // Removed Childhood Experience (Subjective)

  // Geographic & Climate
  {
    id: 'climate',
    category: 'geographic',
    type: 'select',
    question: 'What is your local climate like?',
    options: [
      {value: 'cold',label: 'Cold - Long winters,snow'},
      {value: 'moderate',label: 'Moderate - Four seasons'},
      {value: 'warm',label: 'Warm - Hot summers,mild winters'},
      {value: 'tropical',label: 'Tropical - Hot and humid year-round'},
      {value: 'arid',label: 'Arid - Hot and dry'}
    ],
    weight: 0.7
  },
  // Care Capabilities
  {
    id: 'grooming-commitment',
    category: 'care',
    type: 'select',
    question: 'How much time can you commit to grooming?',
    options: [
      {value: 'minimal',label: 'Minimal - Basic brushing only'},
      {value: 'low',label: 'Low - Weekly brushing'},
      {value: 'moderate',label: 'Moderate - 2-3 times per week'},
      {value: 'high',label: 'High - Daily grooming'},
      {value: 'professional',label: 'Professional - Regular groomer visits'}
    ],
    weight: 0.8
  },
  {
    id: 'exercise-commitment',
    category: 'care',
    type: 'select',
    question: 'How much daily exercise can you provide?',
    options: [
      {value: 'minimal',label: 'Minimal - Indoor play only'},
      {value: 'low',label: 'Low - 15-30 minutes'},
      {value: 'moderate',label: 'Moderate - 30-60 minutes'},
      {value: 'high',label: 'High - 1-2 hours'},
      {value: 'very-high',label: 'Very High - 2+ hours'}
    ],
    weight: 1.0
  },
  {
    id: 'training-experience',
    category: 'care',
    type: 'select',
    question: 'What is your experience with dog training?',
    options: [
      {value: 'none',label: 'No experience'},
      {value: 'basic',label: 'Basic - House training only'},
      {value: 'moderate',label: 'Moderate - Some obedience training'},
      {value: 'experienced',label: 'Experienced - Multiple dogs trained'},
      {value: 'expert',label: 'Expert - Professional or extensive experience'}
    ],
    weight: 0.8
  },
  {
    id: 'budget',
    category: 'care',
    type: 'select',
    question: 'What is your monthly budget for dog care (food,vet,grooming)?',
    options: [
      {value: 'low',label: 'Low - Under $100'},
      {value: 'moderate',label: 'Moderate - $100-200'},
      {value: 'high',label: 'High - $200-400'},
      {value: 'very-high',label: 'Very High - $400+'}
    ],
    weight: 0.7
  },
  // Removed Vet Access (Niche)

  // Preferences (Not dog-specific)
  {
    id: 'noise-tolerance',
    category: 'preferences',
    type: 'select',
    question: 'How do you feel about noise in your living space?',
    options: [
      {value: 'very-sensitive',label: 'Very sensitive - I need quiet'},
      {value: 'sensitive',label: 'Sensitive - Prefer quiet'},
      {value: 'moderate',label: 'Moderate tolerance'},
      {value: 'high',label: 'High tolerance'},
      {value: 'very-high',label: 'Very high - Noise doesn\'t bother me'}
    ],
    weight: 0.8
  },
  {
    id: 'cleanliness-preference',
    category: 'preferences',
    type: 'select',
    question: 'How important is cleanliness in your home?',
    options: [
      {value: 'very-important',label: 'Very important - I keep everything spotless'},
      {value: 'important',label: 'Important - I like things clean'},
      {value: 'moderate',label: 'Moderate - Some mess is okay'},
      {value: 'relaxed',label: 'Relaxed - I don\'t mind mess'},
      {value: 'very-relaxed',label: 'Very relaxed - Cleanliness isn\'t a priority'}
    ],
    weight: 0.7
  }
  // Removed Social Interaction (Niche)
];